import React, { useState } from 'react'
import AddIcon from '@mui/icons-material/Add'
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import useConfirmationAlert from '../../../../hooks/componentHooks/useConfirmationAlert'
import { gradientColors, textColors } from '../../../Common/Color/Color'
import TaskForm from '../TaskForm'
import { RootState } from '../../../../redux/store'
import { useSelector } from 'react-redux'
import { fontSizes } from '../../../Common/Typography/TypographyStyles'

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface TaskCreateModalProps {
  // Define any props if needed
}

const TaskCreateModal: React.FC<TaskCreateModalProps> = () => {
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'))
  const [open, setOpen] = useState(false)
  const [formHasChanges, setFormHasChanges] = useState(false)

  const { ConfirmationAlert, openConfirmationAlert } = useConfirmationAlert()

  const handleCloseModal = () => {
    if (formHasChanges) {
      openConfirmationAlert({
        title: 'Discard changes',
        text: 'Are you sure you want to discard your changes?',
        onConfirm: () => {
          setOpen(false)
        },
      })
    } else {
      setOpen(false)
    }
  }

  const handleOpenModal = () => {
    setOpen(true)
  }

  const handleFormChanges = (hasChanges: boolean) => {
    setFormHasChanges(hasChanges)
  }

  const handleCloseModalAfterSave = () => {
    setOpen(false)
  }

  const role = useSelector((state: RootState) => state.auth.userRole)

  return (
    <React.Fragment>
      {role !== 'teamMember' ? (
        <Button id='create-task-button' startIcon={<AddIcon />} onClick={handleOpenModal} variant='text'>
          Create Task
        </Button>
      ) : null}
      <Dialog open={open} fullWidth fullScreen={fullScreen}>
        <DialogTitle
          sx={{
            background: gradientColors.greenGradient,
            color: textColors.white,
            fontWeight: 'bold',
            fontSize: fontSizes.size20,
          }}
        >
          Create Task
        </DialogTitle>
        <IconButton
          onClick={handleCloseModal}
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            zIndex: 1,
            color: textColors.white,
          }}
          size='small'
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <TaskForm
            action='createTask'
            onSave={handleCloseModalAfterSave}
            onFormChange={handleFormChanges}
          />
        </DialogContent>
      </Dialog>
      {ConfirmationAlert}
    </React.Fragment>
  )
}

export default TaskCreateModal
